"use strict";

module.exports = function () {
  this.selectedRows = [];
  var toggler = document.getElementById('vt-toggle-all');
  toggler.checked = false;
  this.dispatch('select', this.selectedRows);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2-premium/compiled/methods/reset-selected-rows.js
// module id = 923
// module chunks = 0